import {
  Component, OnInit, Input, Output, EventEmitter, ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {Project} from '../../shared/models/project';
import {Size} from '../../shared/models/size';
import {Opening} from '../../shared/models/opening';
import {TileGroupComponent} from '../tile-group/tile-group.component';
import {ChooseSizeDialogComponent} from '../choose-size-dialog/choose-size-dialog.component';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {YesNoDialogComponent} from '../../yesno-dialog/yesno-dialog.component';
import {Shape} from '../../shared/models/shape';
import {RotationViolationDialogComponent} from '../rotation-violation-dialog/rotation-violation-dialog.component';

@Component({
    selector: 'mbnm-builder-size-selector',
    templateUrl: './size-selector.component.html',
    styleUrls: ['./size-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SizeSelectorComponent implements OnInit {

  ngOnInit() {
  }

  constructor(public dialog: MatDialog, private dialogRef:MatDialogRef<SizeSelectorComponent>) {}

  removeOpening(removedOpening:Opening) {
    this.project.removeOpening(removedOpening);
  }

  cantRotateDialog(): void {
    const dialogRef = this.dialog.open(RotationViolationDialogComponent, {});
    dialogRef.componentInstance.project = this.project;
    dialogRef.afterClosed().subscribe(confirmRotate => {
      if (confirmRotate === true) {
        this.project.rotateOuter();
        this.project.rotateOpening();
      }
    });
  }

  rotateOpeningIfPossible($event) {
    $event.stopPropagation();
    $event.preventDefault();
    if (this.project.rotationRestrictions) {
      this.cantRotateDialog();
    } else {
      this.project.rotateOpening();
    }
  }

  rotateOuterIfPossible($event) {
    $event.stopPropagation();
    $event.preventDefault();
    if (this.project.rotationRestrictions) {
      this.cantRotateDialog();
    } else {
      this.project.rotateOuter();
    }
  }

  @ViewChild('tiles')
  public tiles:TileGroupComponent;

  @Output()
  change:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  project:Project;

  @Input()
  tileData:any;

  @Input()
  secondary:boolean = false;

  showVideo:boolean = false;

  createOpening() {
    let size: Size = new Size(this.project.size.width - 4,this.project.size.height - 4);
    let opening: Opening = new Opening(size, [Shape.DEFAULT]);
    this.project.clearOpenings();
    this.project.addOpening(opening);
  }

  public showStandardSizes(): void {

    const config = new MatDialogConfig();
    config.panelClass = 'fullscreen';

    const dialogRef = this.dialog.open(ChooseSizeDialogComponent, config);
    if (this.project.numOpenings > 0 && !this.project.design) {
      dialogRef.componentInstance.mode = 'BOTH-STANDARD';
      dialogRef.componentInstance.title = 'Choose a Standard Size';
    } else {
      dialogRef.componentInstance.mode = 'OUTER-STANDARD';
      dialogRef.componentInstance.title = 'Choose a Size';
    }

    dialogRef.afterClosed().subscribe((results: any) => {
      if (results) {
        this.project.size.width = results.outer[0];
        this.project.size.height = results.outer[1];

        // clear opening if opening is 0x0
        if (results.opening && results.opening[0] === 0 && results.opening[1] === 0) {
          this.project.clearOpenings();
        }

        if (this.project.numOpenings === 1 && results.opening) {
          this.project.opening.size.width = results.opening[0];
          this.project.opening.size.height = results.opening[1];
        }
        this.project.bottomMargin = NaN;
      }
    });
  }

  public learnMoreClicked(): void {

    const config = new MatDialogConfig();
    config.panelClass = 'fullscreen';

    const dialogRef = this.dialog.open(YesNoDialogComponent, config);
    dialogRef.componentInstance.data = {
      title: 'Customization Available!',
      message: '<p>Can\'t find what you\'re looking for? Don\'t worry, we have you covered!</p>' +
               '<p>We offer <strong>multi-opening &amp; non-standard shapes</strong> plus much more.</p>' +
               '<p class="center"><img src="/assets/images/products/custom-designs.jpg" alt="Custom Matboard Designs"/></p>',
      yesButtonText: 'Show Me',
      noButtonText: 'Close',
    };

    dialogRef.afterClosed().subscribe((results: any) => {
      if (results) {
        this.dialogRef.close("NAVIGATE_TO_CUSTOM_DESIGNS");
      }
    });
  }

  openingSizeDimensionChanged($event:any, dim:string) {
    if ($event.newValue === 0) {
      const dialogRef = this.dialog.open(YesNoDialogComponent, {});
      dialogRef.componentInstance.data = {
        title: 'Remove Opening?',
        message: '<p>Remove opening and order a full sheet?</p>',
        yesButtonText: 'Yes',
        noButtonText: 'No'
      };

      dialogRef.afterClosed().subscribe(confirmDelete => {
        if (confirmDelete === true) {
          this.project.clearOpenings();
        } else {
          this.project.opening.size[dim] = $event.oldValue;
        }
      });
    }
  }
}
